export default "__VITE_ASSET__1x4DVNje__"